/**
 * Resource danh mục Mẫu số biên lai
 * ndquang1 16.5.2024
 */
export default {
  Title: 'Mẫu số biên lai',
  Code: 'Mẫu số *',
  CodeTitle: 'Mẫu số',
  Symbol: 'Ký hiệu',
  Kind: 'Loại biên lai'
};
